/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import {FC} from 'react';
import styles from './style.module.less';
import LoadingAnimationJson from 'static/json/datasheet_icon_loading.json';
import SyncAnimationJson from 'static/json/datasheet_icon_sync.json';
import OfflineAnimationJson from 'static/json/datasheet_icon_offline.json';
import OnlineAnimationJson from 'static/json/datasheet_icon_online.json';
import {useMount} from 'ahooks';
import {StatusCode, Strings, t} from '@apitable/core';
import {Tooltip} from '../common';

export enum Network {
  Online = 'online',
  Offline = 'offline',
  Sync = 'sync',
  Loading = 'loading',
}

export const NetworkTip = {
  online: t(Strings.network_icon_hover_connected),
  offline: t(Strings.network_icon_hover_disconnected),
  sync: t(Strings.network_icon_hover_data_synchronization),
  loading: t(Strings.network_icon_hover_reconnection),
};

export interface INetworkStatusProps {
  currentStatus?: Network,
    saveStatus?:number
}

const ID = {
  NETWORK_ONLINE: 'network_online',
  NETWORK_OFFLINE: 'network_offline',
  NETWORK_SYNC: 'network_sync',
  NETWORK_LOADING: 'network_loading',
};

export const NetworkStatus: FC<React.PropsWithChildren<INetworkStatusProps>> = props => {
  const { currentStatus = Network.Online,saveStatus } = props;
    // 添加一个函数来获取当前时间（时分秒）
    const getCurrentTime = () => {
        const now = new Date();
        // 格式化时间为 'HH:mm:ss' 格式
        return now.toLocaleTimeString('zh-CN', {
            hour12: false, // 使用24小时制
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
        });
    };
  useMount(() => {
    import('lottie-web/build/player/lottie_svg').then(module => {
      const lottie = module.default;
 [
      { id: ID.NETWORK_ONLINE, animationData: OnlineAnimationJson },
      { id: ID.NETWORK_OFFLINE, animationData: OfflineAnimationJson},
      { id: ID.NETWORK_SYNC, animationData: SyncAnimationJson},
      { id: ID.NETWORK_LOADING, animationData: LoadingAnimationJson},
    ].forEach(({ id, animationData}) => {
      const el = document.querySelector(`#${id}`);
      if (el) {
        el.innerHTML = '';
        lottie.loadAnimation({
          container: el,
          renderer: 'svg',
          loop: true,
          autoplay: true,
          animationData,
        });
        // const textEl = document.createElement('div');
        // if(saveStatus){
        //     if(saveStatus==StatusCode.COMMON_ERR)
        //         textEl.textContent = "保存失败！";
        //     else
        //         textEl.textContent = "保存成功";
        // }else{
        //     textEl.textContent = text;
        // }
        // textEl.className = styles.statusText;
        // el.appendChild(textEl);
      }
    });

    });
  });

  return (
    <div className={styles.networkStatus}>
      <Tooltip
        title={NetworkTip[currentStatus]}
        placement="bottomRight"
      >
        <div className={styles.network}>
          <div id={ID.NETWORK_ONLINE} style={{ display: currentStatus === Network.Online ? 'flex' : 'none' }} />
          <div id={ID.NETWORK_OFFLINE} style={{ display: currentStatus === Network.Offline ? 'flex' : 'none' }} />
          <div id={ID.NETWORK_SYNC} style={{ display: currentStatus === Network.Sync ? 'flex' : 'none' }} />
          <div id={ID.NETWORK_LOADING} style={{ display: currentStatus === Network.Loading ? 'flex' : 'none' }} />

          <div className={styles.statusText}  style={{ display: saveStatus ===StatusCode.STATUS_OK ? 'flex' : 'none' }} >保存成功{getCurrentTime()}</div>
          <div className={styles.statusText}  style={{ display: saveStatus ===StatusCode.SAVE_ERROR ? 'flex' : 'none' }} >保存失败{getCurrentTime()}</div>
          <div  className={styles.statusText} style={{ display: saveStatus ===StatusCode.SAVE_RUNING ? 'flex' : 'none' }} >数据保存中{getCurrentTime()}</div>
            <div className={styles.statusText}  style={{ display: saveStatus ===StatusCode.SAVE_ERROR_RUNING ? 'flex' : 'none' }} >数据保存中(失败重试）{getCurrentTime()}</div>
            <div className={styles.statusText}  style={{ display: saveStatus ===StatusCode.SAVE_TIMEOUT_RUNING ? 'flex' : 'none' }} >数据保存中(超时重试）{getCurrentTime()}</div>
            <div className={styles.statusText}  style={{ display: saveStatus ===StatusCode.SAVE_RECONNECT_RUNING ? 'flex' : 'none' }} >数据保存中(网络异常重试）{getCurrentTime()}</div>

        </div>
      </Tooltip>
    </div>
  );
};
